import { qualifySelector } from "../utils";

import { MODAL_OPEN, MODAL_CLOSE } from "../constants";

const name = "modal";

const initialState = {
  modalName: "",
  data: {},
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case MODAL_OPEN:
      return {
        modalName: action.payload.modalName,
        data: action.payload.data,
      };

    case MODAL_CLOSE:
      return initialState;

    default:
      return state;
  }
}

export default { [name]: reducer };
export const getModalName = qualifySelector(name, (state) => state.modalName);
export const getModalData = qualifySelector(name, (state) => state.data);
